<template>
  <el-checkbox-group
    v-model="innerValue"
    :size="size"
    :disabled="disabled"
    @change="handleChange"
  >
    <el-checkbox
      v-for="option in optionData"
      :key="option.value"
      :label="option.value"
    >
      {{ option.label }}
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
import { request } from '@/api/service'

export default {
  name: 'InspectionStandardCheckbox',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'mini',
    },
    url: {
      type: String,
      default: '/master/common/dict/system',
    },
    body: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    method: {
      type: String,
      default: 'POST',
    },
    cache: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      innerValue: [],
      optionData: [],
    }
  },
  computed: {
    requestParams() {
      return {
        url: this.url,
        body: this.body,
        params: this.params,
        method: this.method,
        cache: this.cache,
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.innerValue = Array.isArray(val) ? val : []
      },
    },
    requestParams: {
      immediate: true,
      deep: true,
      handler() {
        this.loadOptions()
      },
    },
  },
  methods: {
    async loadOptions() {
      if (!this.url) return
      const res = await request({
        url: this.url,
        method: this.method,
        data: this.body,
        params: this.params,
        cache: this.cache,
      }).catch(() => null)
      this.optionData = res?.body?.data || []
      this.$emit('loaded', this.optionData)
    },
    handleChange(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
  },
}
</script>
